"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _WMTGHDLEcjs = require('../__chunks/WMTGHDLE.cjs');


var _4TRESXTOcjs = require('../__chunks/4TRESXTO.cjs');

// src/checkbox/checkbox-store.ts
function createCheckboxStore(props = {}) {
  var _a;
  _WMTGHDLEcjs.throwOnConflictingProps.call(void 0, props, props.store);
  const syncState = (_a = props.store) == null ? void 0 : _a.getState();
  const initialState = {
    value: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.value,
      syncState == null ? void 0 : syncState.value,
      props.defaultValue,
      false
    )
  };
  const checkbox = _WMTGHDLEcjs.createStore.call(void 0, initialState, props.store);
  return {
    ...checkbox,
    setValue: (value) => checkbox.setState("value", value)
  };
}


exports.createCheckboxStore = createCheckboxStore;
